export default {
  drawer: null,
  color: 'success',
  count: 165,
  notification: {
    show: false,
    icon: 'bell',
    color: 'error',
    timeout: 3000,
    body: '',
    multiline: false,
    link: null
  },
  loading: false,
}
